
import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {
    Container,
    Jumbotron,
    Button
    
}from 'reactstrap';

export default class Home extends Component {
  render() {
    return (
      <div>
            <Jumbotron id="firstJumb">
                <h1>Welcome to Tortilleria Rio</h1>
                <p>Home to Waco's Finest Authentic Mexican Food</p>
            </Jumbotron>
            <Container id="homeCont">
              <div className="row">
                <div className="col-md-6">
                <br/><br/>
                  <h2>Our Food</h2>
                  <p>Our Food Homemade Tortillas, Gorditas, Burritos, and more...</p>
                  <img className="img-fluid swang" alt="our food" src="https://res.cloudinary.com/bobbynicholsoncloud/image/upload/v1530122028/new/menudo.jpg"/>
                </div>
                <div className="col-md-6">
                <br/><br/>
                  <h2>Our Quality</h2>
                  <p>We only serve the best all natural ingredients, no preservatives, non GMO, 100% made fresh from scratch.</p>
                  <img className="img-fluid swang" alt="our quality" src="https://res.cloudinary.com/bobbynicholsoncloud/image/upload/v1528661861/new/authentic.jpg"/>
                </div>
              </div><br/><br/>
              </Container>
              <div id="secondHCont" className="container-fluid text-center">
              <div className="row">
                <div className="col-md-12">
                  <h2>Great Menu...Even Better Prices!</h2>
                  <Link to="/menu">
                  <Button className="button">What's On The Menu?</Button>
                  </Link>
                </div>
                
                </div>
                <div className="row text-center">
                  <div className="col-md-12">
                  <br/> <br/>
                    <div className="container">
                      <ul className="list-group">
                        <li className='list-group-item'><h3 id="testi">Testimonials</h3></li>
                        <li className="list-group-item"><img src="https://res.cloudinary.com/bobbynicholsoncloud/image/upload/v1530122060/new/Screenshot.png" alt="testimonial" className="img-fluid"/></li>
                        <li className="list-group-item"><img src="https://res.cloudinary.com/bobbynicholsoncloud/image/upload/v1530122103/new/Screenshot2.png" alt="testimonial" className="img-fluid"/></li>
                        <li className="list-group-item"><img src="https://res.cloudinary.com/bobbynicholsoncloud/image/upload/v1530122103/new/Screenshot4.png" alt="testimonial" className="img-fluid"/></li>
                        <li className="list-group-item"><img src="https://res.cloudinary.com/bobbynicholsoncloud/image/upload/v1530122103/new/Screenshot3.png" alt="testimonial" className="img-fluid"/></li>
                        <li className="list-group-item"> <a href="https://www.google.com/search?source=hp&ei=UTFKW7-VG5DAsAWUhIe4AQ&q=tortilleria+rio+waco&oq=tor&gs_l=psy-ab.3.0.35i39k1l2j0i20i264k1l2j0i131k1l2j0j0i131k1j0l2.731.791.0.2523.4.2.0.0.0.0.527.721.0j1j5-1.2.0....0...1.1.64.psy-ab..2.2.719.0...0.UQsKWLDyDyo#lrd=0x864f823616bd85f9:0xfb7d9652e77f191b,1,,," className="btn btn-success">See All</a></li>
                      </ul>
                     <br/><br/>
                    </div>
                  </div>
              </div>
              
            </div>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Home.js